module.exports = __webpack_public_path__ + "img/P150T_weapon_127.3119c1b3.png";